/**
 * Internal Audit workflow stages, role responsibilities and plan constants.
 */

export const IA_WORKFLOW_STAGES = [
  { key: "plan_creation", label: "Plan Creation" },
  { key: "agreement", label: "Agreement" },
  { key: "questionnaire_scheduling", label: "Questionnaire & Scheduling" },
  { key: "audit_conduct", label: "Audit Conduct" },
  { key: "review_signoff", label: "Review & Sign-off" },
];

export const IA_WORKFLOW_ROLES = [
  { key: "lead_advisor", label: "Lead Advisor" },
  { key: "company_spoc", label: "Company SPOC" },
  { key: "company_delegate", label: "Company Delegate" },
  { key: "advisor", label: "Advisor" },
];

/**
 * Who does what at each stage (Workflow document, Internal Audit slide). Responsibilities only: whether a
 * stage is done or current is derived from the stored package (see deriveIaStageStates), never from here.
 */
export const IA_WORKFLOW_MATRIX = {
  lead_advisor: {
    plan_creation: "Create audit plan & circulate",
    questionnaire_scheduling: "Book calendars",
    audit_conduct: "Facilitate IA conduct",
  },
  company_spoc: {
    agreement: "Agree with plan",
    questionnaire_scheduling: "Respond to questions",
    audit_conduct: "Conduct Mgmt review & propose action plan",
    review_signoff: "Sign off IA report & action plan",
  },
  company_delegate: {
    agreement: "Agree with plan",
    questionnaire_scheduling: "Respond to questions",
    audit_conduct: "Agree with action plan",
  },
  advisor: {
    agreement: "Agree with plan",
    questionnaire_scheduling: "Setup questionnaire & conduct audit",
    audit_conduct: "Complete checklist & submit findings",
  },
};

export const AUDIT_PLAN_STATUS_OPTIONS = [
  { value: "not_started", label: "Not started" },
  { value: "scheduled", label: "Scheduled" },
  { value: "in_progress", label: "In progress" },
  { value: "completed", label: "Completed" },
];

export const AUDIT_PLAN_CSV_COLUMNS = [
  "ID",
  "Clause",
  "Audit Area",
  "Auditor",
  "Auditee",
  "Scheduled Date",
  "Status",
];
